import React from 'react';
import PropTypes from 'prop-types';
import { getElapsedTime } from '../../helpers/utils';
import './css/modificationStats.css';
import { UploadCloud, Edit3 } from 'react-feather';

const ModificationStats = ({ createdOn, createdBy, modifiedOn, modifiedBy }) => {
	return (
		<div className='modification-stats'>
			{createdOn && createdBy && (
				<p>
					<UploadCloud size={14} /> published {' '}
					<strong className='uitest-createdon'>{getElapsedTime(createdOn, false)}</strong> by{' '}
					<strong className='uitest-createdby'>{createdBy}</strong>
				</p>
			)}
			{modifiedOn && modifiedBy && (
				<p>
					<Edit3 size={14} /> last edited {' '}
					<strong className='uitest-modifiedon'>{getElapsedTime(modifiedOn, false)}</strong> by{' '}
					<strong className='uitest-modifiedby'>{modifiedBy}</strong>
				</p>
			)}
		</div>
	);
};

ModificationStats.propTypes = {
	createdOn: PropTypes.string,
	createdBy: PropTypes.string,
	modifiedOn: PropTypes.string,
	modifiedBy: PropTypes.string
};

export default ModificationStats;
